"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lib_1 = require("../../../lib");
var surface_1 = require("../../../lib/components/surface");
var MinutesGenerator_1 = require("./components/MinutesGenerator");
var HoursGenerator_1 = require("./components/HoursGenerator");
var DaysGenerator_1 = require("./components/DaysGenerator");
var MonthGenerator_1 = require("./components/MonthGenerator");
var CronGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(CronGenerator, _super);
    function CronGenerator(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onMinutesGenerate = function (cronMinutes) {
            _this.setState({ cronMinutes: cronMinutes });
            _this.props.onGenerate && _this.props.onGenerate(_this.generateCron());
        };
        _this.onHoursGenerate = function (cronHours) {
            _this.setState({ cronHours: cronHours });
            _this.props.onGenerate && _this.props.onGenerate(_this.generateCron());
        };
        _this.onDaysGenerate = function (cronDays) {
            _this.setState({ cronDays: cronDays });
            _this.props.onGenerate && _this.props.onGenerate(_this.generateCron());
        };
        _this.onMonthGenerate = function (cronMonths) {
            _this.setState({ cronMonths: cronMonths });
            _this.props.onGenerate && _this.props.onGenerate(_this.generateCron());
        };
        _this.state = {
            tabIndex: 2,
            cronMinutes: "0",
            cronHours: "*",
            cronDays: "*",
            cronMonths: "*"
        };
        return _this;
    }
    CronGenerator.prototype.generateCron = function () {
        var _a = this.state, cronMinutes = _a.cronMinutes, cronHours = _a.cronHours, cronDays = _a.cronDays, cronMonths = _a.cronMonths;
        return "0 " + cronMinutes + " " + cronHours + " " + cronDays + " " + cronMonths + " *";
    };
    CronGenerator.prototype.render = function () {
        var _this = this;
        var theme = this.props.theme;
        return (React.createElement("div", null,
            React.createElement(lib_1.TabsPanel, { selectedIndex: this.state.tabIndex, onChange: function (tabIndex) { return _this.setState({ tabIndex: tabIndex }); } },
                React.createElement(lib_1.Tab, { label: "Minutes" },
                    React.createElement(surface_1.Surface, { level: 1, className: theme.tabContainer },
                        React.createElement(MinutesGenerator_1.default, { theme: theme, onGenerate: this.onMinutesGenerate }))),
                React.createElement(lib_1.Tab, { label: "Hours" },
                    React.createElement(surface_1.Surface, { level: 1 },
                        React.createElement(HoursGenerator_1.default, { theme: theme, onGenerate: this.onHoursGenerate }))),
                React.createElement(lib_1.Tab, { label: "Days" },
                    React.createElement(surface_1.Surface, { level: 1 },
                        React.createElement(DaysGenerator_1.default, { theme: theme, onGenerate: this.onDaysGenerate }))),
                React.createElement(lib_1.Tab, { label: "Month" },
                    React.createElement(surface_1.Surface, { level: 1 },
                        React.createElement(MonthGenerator_1.default, { theme: theme, onGenerate: this.onMonthGenerate }))))));
    };
    CronGenerator.defaultProps = {};
    return CronGenerator;
}(React.Component));
exports.default = CronGenerator;
